import { isEqual } from 'lodash';
import { IProduct } from 'types/productCatalogTypes';

export const isLanguagesFormTouched = (product: IProduct, values: IProduct): boolean => {
  return (
    !isEqual(product.nameTranslations, values.nameTranslations) ||
    !isEqual(product.descriptionTranslations, values.descriptionTranslations)
  );
};
